/**
 * Created by rhinov15 on 18/07/2017.
 *
 * Canopy joinery entity node (verrière)
 */

import { JoineryNode } from "../JoineryNode";
import { PlanManager } from "../../../../../cocosPlan";
import { Canopy } from "@rhinov/savane-js";

declare var cc: any;

export class CanopyNode extends JoineryNode {
    constructor(jOpening: Canopy){
        // Call super class constructor
        super(jOpening);
        // And prepare the node for display
        this.computeModel(jOpening);
    }

    // Prepare node for display
    override computeModel (joinery: Canopy) {
        // Retrieve joinery parameters if not undefined
        if (joinery !== undefined) {
            this._length = joinery.length;
            if (joinery.wall != null)
                this._thickness = joinery.wall.thickness;
            else
                this._thickness = this._length / 10;

            this._nbCasement = joinery.nbCasement;
            this._wallInstallTye = joinery.wallInstallType;
        }

        // Create one sprite per casement of the canopy
        for (var i = 0; i < this._nbCasement; ++i) {
            // New sprite
            var sprite = new cc.Sprite();

            // Sprite texture image name
            var spriteName = this._nbCasement > 1 ? (i % 2 == 0 ? 'plan/bayBot.png' : 'plan/bayBot.png') : 'plan/bayBot.png';
            // Init sprite texture image
            sprite.initWithSpriteFrameName(spriteName);
            // Set anchoring
            sprite.setAnchorPoint(new cc.p((i + 1) - (this._nbCasement * 0.5), 0));

            if (this.transparentDraw) {
                sprite.setOpacity(64);
            }

            // Set scale X and Y
            sprite.setScaleX(this._length / (sprite.width * 10 * this._nbCasement));
            sprite.setScaleY(0.26);
            // Set position and name
            sprite.setPositionY(this.getY(10));
            sprite.setName('door-' + i);
            // And add the sprite to the rendering
            this.addChild(sprite, 8);
        }
    }

    getY (h: number): number | undefined {
        switch (this._wallInstallTye) {
            case 1:
                return -(this._thickness * 0.1) * 0.5;
                break;

            case 0:
                return (-h * 0.5);
                break;

            case -1:
                return ((this._thickness * 0.1) * 0.5 - 10);
                break;
        }
    }

    // Draw manual rectangles for the node
    drawOverlap (joinery: Canopy, isValid: boolean) {
        var alpha = 255;
        if (this.transparentDraw) {
            alpha = 64;
        }

        // Clear the node display
        this.clear();
        // If the node thickness > 0 (it would be invisible)
        if (this._thickness > 0) {
            // x, y, w, h of the element being displayed
            var h = (this._thickness * 0.1);
            var w = this._length * 0.1 - 1;
            var y = -h * 0.5;
            var x = -w * 0.5;
            // Color to use for the display
            var color: {border: any, plain:any} = {border: undefined, plain: undefined};
            // Border size
            var borderSize = 1;

            // Select color depending on valid/invalid, selected/unselected
            if (isValid !== undefined) {
                color = this.getOverLapColor(isValid);
            }
            else {
                color = this.getOverLapColor(true);
            }

            if (borderSize * PlanManager.getInstance().getZoomScale() < 1) {
                borderSize /= PlanManager.getInstance().getZoomScale();
            }
            var white = new cc.color(255, 255, 255, alpha);
            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), white, borderSize, white);

            // Default door thickness
            h = (100 * 0.1);

            y = this.getY(h) as number;

            this.drawRect(new cc.p(x, y), new cc.p(x + w, y + h), color.plain, borderSize, color.border);
            this.drawRect(new cc.p(x - 0.5, y - 0.5), new cc.p(x + w * 0.015, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
            this.drawRect(new cc.p(x + w - w * 0.015, y - 0.5), new cc.p(x + w + 0.5, y + h + 0.5), new cc.Color(66, 80, 94, alpha), 1, new cc.Color(66, 80, 94, 0));
        }
    }

    // Update node model, prepare for next frame display
    updateModel (joinery: Canopy, isValid: boolean) {
        // Empty current node display
        this.removeAllChildren();
        // Add prepare the content to display
        this.computeModel(joinery);
        // Call Joinery node update model method
        super.updateModel(joinery, isValid);
        // Draw node additionnal rects
        this.drawOverlap(joinery, isValid);
    }
}
